const NotificationEmailTemplateModel = function () {

    this.notificationEmailTemplate = {};
    this.hasUnsavedChanges = false;
    this.isValid = false;

    this.reset = function () {
        this.notificationEmailTemplate = {};
        this.hasUnsavedChanges = false;
        this.isValid = false;
    };
};

angular.module('ums.configuration')
    .service('notificationEmailTemplateModel', NotificationEmailTemplateModel);
